import(/* webpackMode: "eager" */ "/app/node_modules/@mui/material/Box/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/material/Divider/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/material/Grid/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/material/Skeleton/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/material/Stack/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/material/Typography/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/(root)/(lading)/blog/lazyRelatedBlog/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/DynamicImage/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/NextImage/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ProductCard/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default","error"] */ "/app/src/components/Toastify/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["useLayoutContext"] */ "/app/src/layouts/provider.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/sections/home/carousel-controller.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/sections/home/carousel-controller.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/sections/home/flash-sale/carousel-product-sale.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/sections/home/flash-sale/title-flash-sale.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/sections/home/home-section-container.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/sections/home/policy.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/sections/home/popup-banner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/sections/home/product-tabs.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/sections/home/voucher.tsx");
